import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiHome, FiUsers, FiBriefcase, FiCalendar, FiClock, FiDollarSign, FiSettings, FiLogOut, FiUserPlus, FiGift, FiList, FiGrid, FiClipboard } from 'react-icons/fi';

const allLinks = [
  { to: '/dashboard', icon: <FiHome />, label: 'Dashboard', roles: ['admin', 'hr', 'employee'] },
  { to: '/employees', icon: <FiUsers />, label: 'Employees', roles: ['admin', 'hr'] },
  { to: '/departments', icon: <FiBriefcase />, label: 'Departments', roles: ['admin', 'hr'] },
  { to: '/leaves', icon: <FiCalendar />, label: 'Leaves', roles: ['admin', 'hr', 'employee'] },
  { to: '/leave-balances', icon: <FiList />, label: 'Leave Balances', roles: ['admin', 'hr'] },
  { to: '/holidays', icon: <FiGift />, label: 'Holidays', roles: ['admin', 'hr', 'employee'] },
  { to: '/calendar', icon: <FiGrid />, label: 'My Calendar', roles: ['admin', 'hr', 'employee'] },
  { to: '/projects', icon: <FiClipboard />, label: 'Projects', roles: ['admin', 'hr', 'employee'] },
  { to: '/attendance', icon: <FiClock />, label: 'Attendance', roles: ['admin', 'hr', 'employee'] },
  { to: '/payroll', icon: <FiDollarSign />, label: 'Payroll', roles: ['admin', 'hr'] },
  { to: '/register', icon: <FiUserPlus />, label: 'Register User', roles: ['admin'] },
  { to: '/settings', icon: <FiSettings />, label: 'Settings', roles: ['admin', 'hr', 'employee'] },
];

const Sidebar = () => {
  const { user, logout } = useAuth();
  const role = user?.role;
  const links = allLinks.filter((link) => link.roles.includes(role));

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>HRMS</h2>
        <p className="sidebar-subtitle">Human Resource System</p>
      </div>
      <nav className="sidebar-nav">
        {links.map((link) => (
          <NavLink key={link.to} to={link.to} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            {link.icon} <span>{link.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">{user?.name?.charAt(0).toUpperCase()}</div>
          <div>
            <div className="sidebar-username">{user?.name}</div>
            <div className="sidebar-role">{user?.role}</div>
          </div>
        </div>
        <button className="sidebar-logout" onClick={logout}><FiLogOut /> Logout</button>
      </div>
    </div>
  );
};

export default Sidebar;
